import { render, staticRenderFns } from "./SocialOrganicInstagramGridComponent.vue?vue&type=template&id=6fc9ca89&scoped=true"
import script from "./SocialOrganicInstagramGridComponent.vue?vue&type=script&lang=js"
export * from "./SocialOrganicInstagramGridComponent.vue?vue&type=script&lang=js"
import style0 from "./SocialOrganicInstagramGridComponent.vue?vue&type=style&index=0&id=6fc9ca89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc9ca89",
  null
  
)

export default component.exports